import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
} from 'react';
import { stateKeys } from '../../constants';
import { useStateControllers } from '../../stateManager';

const noop = () => {};
const emptyArray = [];
const key = stateKeys.expandedRowKeys;

const Context = createContext();

export const useRowExpansionHandler = () => useContext(Context);

export const RowExpansionProvider = ({ children, ...props }) => {
  const { value, onChange = noop, defaultValue } = props ?? {};

  const isControlledRef = useRef(Object.hasOwn(props, 'value'));

  const { setValue, getValue } = useStateControllers();

  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  const changeHandler = useCallback(
    ({ rowKey, expanded }) => {
      const current = getValue(key) ?? emptyArray;

      const next = expanded
        ? [...current, rowKey]
        : current.filter((key) => key !== rowKey);

      onChangeRef.current(next);

      if (!isControlledRef.current) {
        setValue(key, next);
      }
    },
    [getValue, setValue]
  );

  useEffect(() => {
    if (isControlledRef.current) {
      setValue(key, value);
    } else if (defaultValue) {
      setValue(key, defaultValue);
    }
  }, [value, defaultValue, setValue]);

  return <Context.Provider value={changeHandler}>{children}</Context.Provider>;
};
